// extracted by mini-css-extract-plugin
export default {"collections":"CollectionsExample_collections__UUgIA","slide":"CollectionsExample_slide__8-gW8"};